import React, { useState, useRef } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ColorPicker } from 'primereact/colorpicker';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Slider } from 'primereact/slider';
import {ProgressSpinner} from 'primereact/progressspinner';
import { InputSwitch } from 'primereact/inputswitch';
import FontDropdown from './FontDropdown';

const submitHex = require('../color-algo');
const submitHexInOklab = require('../color-algo-oklab');
const formatColorMappings = require('../color-formatter');
const injectCSSVariables = require('../injectStyle');


function Chat({ onAutoTabSwitch }) {
  const colorChangeTimeout = useRef(null);
  const [activeIndex, setActiveIndex] = useState([0]);
  const [useOklab, setUseOklab] = useState(false);
  
  const [colorBrand, setColorBrandState] = useState('066AFE');

  const [colorHeader, setColorHeaderState] = useState('#ffffff');

  const [colorAccents, setColorAccentsState] = useState({
    accent1: '066AFE',
    accent2: '#0250d9',
    accent3: '#022ac0',
    container1: '#066AFE',
    container2: '#0250d9',
    container3: '#022ac0',
    border1: '#066AFE',
    border2: '#0250d9',
    border3: '#022ac0'
  });

  const [colorFeedbacks, setColorFeedbacksState] = useState({
    success: '#056764',
    error: '#b60554',
    warning: '#8c4b02',
    info: '#0b5cab',
  });

  const [nonColorProperties, setNonColorPropertiesState] = useState({
    borderRadius: 50,
    borderThickness: 50,
    fontSize: 50,
    fontWeight: 50,
    lineHeight: 50,
    spacing: 50
  });

  const [propertyShadow, setPropertyShadowsState] = useState({
    color: '',
    xaxis: '',
    yaxis: '',
    blur: '',
    spread: ''
  });

  const [brandColorUpdated, refreshBrandColorSections] = useState(false);


const setBrandColor = (key, value) => {
  setColorBrandState(value);
  refreshBrandColorSections(true);
  console.log("Inside setBrandColor event handler");
    if (colorChangeTimeout.current) {
      clearTimeout(colorChangeTimeout.current);
    }
    colorChangeTimeout.current = setTimeout(() => {
      if(isValidHex("#"+value)) {
        console.log(`SETTING the ${key} of ${value}`);
        const colorPalette = useOklab ? submitHexInOklab(value) : submitHex(value);
        const styleMappings = formatColorMappings(colorPalette, key);
        console.log("STYLE  MAPPINGS: ", styleMappings);
        injectCSSVariables(styleMappings);
        let accentColor1, accentColor2, accentColor3;
        styleMappings.forEach(obj => {
          if(obj.name === "--slds-g-color-accent-1") {
            accentColor1 = extractHexFromLightDark(obj.value);
          }
          else if (obj.name === "--slds-g-color-accent-2") {
            accentColor2 = extractHexFromLightDark(obj.value);
          } 
          else if (obj.name === "--slds-g-color-accent-3") {
            accentColor3 = extractHexFromLightDark(obj.value);
          }
        });
        
        setColorAccentsState(prev => ({
          ...prev,
          accent1: accentColor1 ,
          accent2: accentColor2,
          accent3: accentColor3,
          container1: accentColor1,
          container2: accentColor2,
          container3: accentColor3,
          border1: accentColor1,
          border2: accentColor2,
          border3: accentColor3
        }));
        refreshBrandColorSections(false);
      }
    }, 300);
}

const setHeaderColor = (key, value) => {
  if (colorChangeTimeout.current) {
    clearTimeout(colorChangeTimeout.current);
    colorChangeTimeout.current = setTimeout(() => {
      setColorBrandState(value);
    }, 300);

  }
  console.log(`SETTING the ${key} of ${value}`);
  // const colorPalette = submitHex(value);
  // console.log("colorPalette for", key, colorPalette);
  // const styleMappings = formatColorMappings(colorPalette, key);
  // console.log("STYLE  MAPPINGS: ", styleMappings);
  // injectCSSVariables(styleMappings);
}

const setFeedbackColor = (key, value) => {
  if (colorChangeTimeout.current) {
    clearTimeout(colorChangeTimeout.current);
  }
  colorChangeTimeout.current = setTimeout(() => {
    setColorFeedbacksState(prev => ({
      ...prev,
      [key]: value
    }));
  }, 300);

  console.log(`SETTING the ${key} of ${value}`);
  const colorPalette = useOklab ? submitHexInOklab(value) : submitHex(value);
  console.log("colorPalette for", key, colorPalette);
  const styleMappings = formatColorMappings(colorPalette, key);
  injectCSSVariables(styleMappings);
  
  return;
}
  
const setAccentColor = (key, value, hook) => {
  console.log("VALUE: ", value, "HOOK:", hook);
  if (colorChangeTimeout.current) {
    clearTimeout(colorChangeTimeout.current);
  }
  colorChangeTimeout.current = setTimeout(() => {
    setColorAccentsState(prev => ({
      ...prev,
      [key]: value
    }));
  }, 300);

  console.log(`SETTING the ${key} of ${value}`);
  injectCSSVariables([{
    name: `--slds-g-${hook}`,
    value: `#${value}`
  }])
}

const isValidHex = (hex) => {
    console.log("H E X ", hex);
    return (hex.match(/#?[0-9a-fA-F]{6}/)) !== null
}

const extractHexFromLightDark = (expr) => {
  if (expr.startsWith("light-dark(")) {
    const inside = expr.slice("light-dark(".length, -1); // remove 'light-dark(' and ')'
    const firstHex = inside.split(",")[0].trim();
    return firstHex;
  }
  return expr;
}

const setNonColorProperty = (key, value) => {
  // if (colorChangeTimeout.current) {
  //   clearTimeout(colorChangeTimeout.current);
  // }
  // colorChangeTimeout.current = setTimeout(() => {
    setNonColorPropertiesState(prev => ({
      ...prev,
      [key]: value
    }));
  // }, 300);

  // Auto tab switching logic based on specific properties
  onAutoTabSwitch('pages');
  // if (onAutoTabSwitch) {
  //   const tabSwitchMap = {
  //     'fontSize': 'components',      // Font size changes -> Components tab
  //     'fontWeight': 'components',    // Font weight changes -> Components tab
  //     'lineHeight': 'components',    // Line height changes -> Components tab
  //     'borderRadius': 'pages',       // Border radius changes -> Pages tab
  //     'borderThickness': 'pages',    // Border thickness changes -> Pages tab
  //     'spacing': 'pages'             // Spacing changes -> Pages tab
  //   };

  //   if (tabSwitchMap[key]) {
  //     onAutoTabSwitch(tabSwitchMap[key]);
  //   }
  // }

  // const colorPalette = submitHex(value);
  console.log("Scale Factor for", key, value);
  injectCSSVariables(value, key);
  
  return ;
}
    
  return (
    <div className='chatArea chatsContainer'>
        {/* <div className='chatHeader'>
          <h2 className='title'>Advanced Theming & Branding <span>(PoC)</span></h2>
        </div> */}
        <div className='messagesArea'>
        {/* <div className="slds-grid slds-wrap">
          <div className="slds-col slds-size_8-of-12 slds-p-around_small">
            <label htmlFor="brandColor">Brand Color</label>
            <div className="slds-grid slds-m-top_x-small">
              <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorBrand} onChange={(e) => setBrandColor('brand', e.value)}/>
              <InputText id="brandColor" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorBrand} onChange={(e) => setBrandColor('brand', e.value)} />
            </div>
          </div>
          <div className="slds-col slds-size_12-of-12 slds-p-around_small">
            <label htmlFor="brandColor">Generated Color Palette</label>
            <div className="slds-grid slds-m-top_x-small" style={{height: "50px"}}>
              <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-accent-dark-1)`}}></div>
              <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-accent-1)`}}></div>
              <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-accent-3)`}}></div>
              <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-accent-light-2)`}}></div>
              <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-accent-light-1)`}}></div>
            </div>
          </div>
        </div> */}
          <Accordion multiple activeIndex={[0]}>
          <AccordionTab header="Brand Color">
          <div className="slds-grid slds-gutters slds-wrap">
              <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                <label className="slds-m-bottom_xx-small" htmlFor="accent1">Choose your brand color</label>
                <div className="slds-grid slds-m-top_x-small">
                  <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorBrand} onChange={(e) => setBrandColor('brand', e.value)}/>
                  <InputText id="brandColor" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={"#"+colorBrand} onChange={(e) => setBrandColor('brand', e.value)} /> 
                </div>
              </div>
              <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                <label className="slds-m-bottom_xx-small" htmlFor="colorSpace">Color Space</label>
                <div className="slds-grid slds-m-top_x-small slds-grid_vertical-align-center">
                  <span className="slds-m-right_x-small">LCH</span>
                  <InputSwitch 
                    checked={useOklab} 
                    onChange={(e) => {
                      setUseOklab(e.value);
                      // Recalculate colors with current brand color using new color space
                      setBrandColor('brand', colorBrand);
                    }} 
                  />
                  <span className="slds-m-left_x-small">Oklab</span>
                </div>
              </div>
              <div className="slds-col slds-size_12-of-12 slds-p-around_small">
                <label htmlFor="accent2">Generated Color Palette</label>
                <div className="slds-grid slds-m-top_x-small preview-palette" style={{height: "50px"}}>
                  <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-brand-20, var(--slds-g-color-accent-dark-1))`}}></div>
                  <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-brand-30, var(--slds-g-color-accent-1))`}}></div>
                  <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-brand-50, var(--slds-g-color-accent-3))`}}></div>
                  <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-brand-90, var(--slds-g-color-accent-light-2))`}}></div>
                  <div className='slds-size_2-of-12 slds-p-around_small' style={{background: `var(--slds-g-color-brand-95, var(--slds-g-color-accent-light-1))`}}></div>
                </div>
              </div>
            </div>
            </AccordionTab>
            <AccordionTab header="Header Color" disabled>
                <p className="m-0">
                  The header background color is the color of the area on the top of every screen behind the logo, search, and top-right icons.
                </p>
                <div className="slds-grid slds-wrap">
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label className="slds-m-bottom_medium" htmlFor="colorHeader">Header Background</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12" format="hex" value={colorHeader} onChange={(e) => setHeaderColor('header', e.value)}/>
                    <InputText id="colorHeader" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorHeader} onChange={(e) => setHeaderColor('header', e.value)} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
            <AccordionTab header="Accent Colors">
                <p className="m-0">
                  Accent colors are the colors used to highlight active states of UI elements like navigation and tabs. It also is used on primary buttons and links.
                </p>
                {!brandColorUpdated && 
                (<div className="slds-grid slds-gutters slds-wrap">
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label className="slds-m-bottom_medium" htmlFor="accent1">Primary Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.accent1} onChange={(e) => setAccentColor('accent1', e.value, "color-accent-1")}/>
                    <InputText id="accent1" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={"#"+colorAccents.accent1} onChange={(e) => setAccentColor('accent1', e.value, "color-accent-1")} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accent2">Secondary Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.accent2} onChange={(e) => setAccentColor('accent2', e.value, "color-accent-2")}/>
                    <InputText id="accent2" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.accent2} onChange={(e) => setAccentColor('accent2', e.value, "color-accent-2")}/>
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accent3">Tertiary Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorAccents.accent3} onChange={(e) => setAccentColor('accent3', e.value, "color-accent-3")}/>
                    <InputText id="accent3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.accent3} onChange={(e) => setAccentColor('accent3', e.value, "color-accent-3")}/>
                  </div>
                </div>
                </div>)
                }
                {brandColorUpdated && 
                  (
                    <div className="slds-grid slds-m-top_medium">
                      <ProgressSpinner aria-label="Loading" style={{ width: '40px', height: '40px' }} />
                    </div>
                  )
                }
            </AccordionTab>
            <AccordionTab header="Accent Container Colors">
                <p className="m-0">
                  Container colors are the colors of the background of cards and other areas signifying a section of content
                </p>
                {!brandColorUpdated && 
                  (<div className="slds-grid slds-gutters slds-wrap">
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label className="slds-m-bottom_medium" htmlFor="accentContainer1">Primary Container Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.container1}  onChange={(e) => setAccentColor('container1', e.value, "color-accent-container-1")}/>
                    <InputText id="accentContainer1" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.container1}  onChange={(e) => setAccentColor('container1', e.value, "color-accent-container-1")} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer2">Secondary Container Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.container2} onChange={(e) => setAccentColor('container2', e.value, "color-accent-container-2")}/>
                    <InputText id="accentContainer2" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.container2} onChange={(e) => setAccentColor('container2', e.value, "color-accent-container-2")} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Tertiary Container Accent</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorAccents.container3} onChange={(e) => setAccentColor('container3', e.value, "color-accent-container-3")}/>
                    <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.container3} onChange={(e) => setAccentColor('container3', e.value, "color-accent-container-3")} />
                  </div>
                </div>
                  </div>)
                }
                {brandColorUpdated && 
                  (
                    <div className="slds-grid slds-m-top_medium">
                      <ProgressSpinner aria-label="Loading" style={{ width: '40px', height: '40px' }} />
                    </div>
                  )
                }
            </AccordionTab>
            <AccordionTab header="Feedback Colors">
                <p className="m-0">
                  Feedback colors include the group of colors included in notifications, errors, warnings, and success messages.
                </p>
                <div className="slds-grid slds-gutters slds-wrap">
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label className="slds-m-bottom_medium" htmlFor="accentContainer1">Success State</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <ColorPicker className="slds-size_2-of-12" format="hex" value={colorFeedbacks.success} onChange={(e) => setFeedbackColor( "success", e.value)}/>
                      <InputText id="accentContainer1" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorFeedbacks.success}  onChange={(e) => setFeedbackColor( "success", e.value)}/>
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer2">Error State</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <ColorPicker className="slds-size_2-of-12" format="hex" value={colorFeedbacks.error} onChange={(e) => setFeedbackColor("error", e.value)}/>
                      <InputText id="accentContainer2" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorFeedbacks.error} onChange={(e) => setFeedbackColor("error", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Warning State</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" value={colorFeedbacks.warning} onChange={(e) => setFeedbackColor("warning", e.value)}/>
                      <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorFeedbacks.warning} onChange={(e) => setFeedbackColor("warning", e.value)}/>
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Info State</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorFeedbacks.info} onChange={(e) => setFeedbackColor("info", e.value)}/>
                      <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorFeedbacks.info} onChange={(e) => setFeedbackColor("info", e.value)} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
            <AccordionTab header="Borders">
                <p className="m-0">
                Border settings include the colors of borders that surround content including their containers, the corner radius, and the thickness of the border line. There are 4 radius values created by the derivative in this setting. Each value scales by a multiple of 8px in what's commonly referred to as a base-8 grid scale.
                </p>
                {!brandColorUpdated && 
                  (<div className="slds-grid slds-gutters slds-wrap">
                    <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                      <label className="slds-m-bottom_medium" htmlFor="accentContainer1">Primary Border Accent</label>
                      <div className="slds-grid slds-m-top_x-small">
                        <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.border1} onChange={(e) => setAccentColor('border1', e.value, "color-border-accent-1")}/>
                        <InputText id="accentContainer1" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.border1} onChange={(e) => setAccentColor('border1', e.value, "color-border-accent-1")} />
                      </div>
                    </div>
                    <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                      <label htmlFor="accentContainer2">Secondary Border Accent</label>
                      <div className="slds-grid slds-m-top_x-small">
                        <ColorPicker className="slds-size_2-of-12" format="hex" value={colorAccents.border2} onChange={(e) => setAccentColor('border2', e.value, "color-border-accent-2")}/>
                        <InputText id="accentContainer2" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.border2} onChange={(e) => setAccentColor('border2', e.value, "color-border-accent-2")} />
                      </div>
                    </div>
                    <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                      <label htmlFor="accentContainer3">Tertiary Border Accent</label>
                      <div className="slds-grid slds-m-top_x-small">
                        <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value={colorAccents.border3} onChange={(e) => setAccentColor('border3', e.value, "color-border-accent-3")}/>
                        <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={colorAccents.border3} onChange={(e) => setAccentColor('border3', e.value, "color-border-accent-3")} />
                      </div>
                    </div>
                  </div>)
                }
                {brandColorUpdated && 
                  (
                    <div className="slds-grid slds-m-top_medium">
                      <ProgressSpinner aria-label="Loading" style={{ width: '40px', height: '40px' }} />
                    </div>
                  )
                }
                <div className="slds-grid slds-gutters slds-wrap slds-grid_vertical-align-center">
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Border Radius</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.borderRadius}  onChange={(e) => setNonColorProperty("borderRadius", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0 - 100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.borderRadius}  onChange={(e) => setNonColorProperty("borderRadius", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Border Thickness</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.borderThickness}  onChange={(e) => setNonColorProperty("borderThickness", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0-100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.borderThickness}  onChange={(e) => setNonColorProperty("borderThickness", e.value)} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
            <AccordionTab header="Shadow" disabled>
                <p className="m-0">
                Shadows include the visual style that appears behind elevated content including cards and dialogs. There are 4 shadow values created by the derivative in this setting. Each value scales by a multiple of 8px in what's commonly referred to as a base-8 grid scale.
                </p>
                <div className="slds-grid slds-gutters slds-wrap">
                <div className="slds-col slds-size_8-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Color</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <ColorPicker className="slds-size_2-of-12 slds-max-small-size_3-of-12" format="hex" value="#1589EE" onChange={(e) => {}}/>
                      <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={0} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label className="slds-m-bottom_medium" htmlFor="accentContainer1">X-Axis Offset Derivative</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputText id="accentContainer1" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={0} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer2">Y-Axis Offset Derivative</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputText id="accentContainer2" className="slds-size_8-of-12 slds-m-left_x-small p-inputtext-sm" value={0} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Blur Derivative</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={0} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_6-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Spread Derivative</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputText id="accentContainer3" className="slds-size_8-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={0} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
            <AccordionTab header="Spacing">
                <p className="m-0">
                Spacing is the padding around content that creates separation from other elements on the page. There are 12 spacing values created by the derivative in this setting. Each value scales by a multiple of 8px in what's commonly referred to as a base-8 grid scale.
                </p>
                <div className="slds-grid slds-gutters slds-wrap slds-grid_vertical-align-center">
                  <div className="slds-col slds-size_7-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Spacing Derivative Value</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.spacing}  onChange={(e) => setNonColorProperty("spacing", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_5-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0 - 100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.spacing}  onChange={(e) => setNonColorProperty("spacing", e.value)} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
            <AccordionTab header="Typography">
                <p className="m-0">
                Typography settings include the text size, spacing, and weight in all content. There are 10 font size, 6 line height, and 6 font weight values created by the derivative in this setting. Each value scales by a multiple of 8px in what's commonly referred to as a base-8 grid scale.
                </p>
                <div className="slds-grid slds-gutters slds-wrap slds-grid_vertical-align-center">
                <div className="slds-col slds-size_7-of-12 slds-m-top_medium">
                    <label htmlFor="font-dropdown">Choose fonts</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <FontDropdown onAutoTabSwitch={onAutoTabSwitch}/>
                    </div>
                  </div>
                  <div className="slds-col slds-size_7-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Font Size Derivative Value</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.fontSize}  onChange={(e) => setNonColorProperty("fontSize", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_5-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0 - 100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.fontSize}  onChange={(e) => setNonColorProperty("fontSize", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_7-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Line Height Derivative Value</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.lineHeight}  onChange={(e) => setNonColorProperty("lineHeight", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_5-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0 - 100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.lineHeight}  onChange={(e) => setNonColorProperty("lineHeight", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_7-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">Font Weight Derivative Value</label>
                    <div className="slds-grid slds-m-top_x-small">
                      <InputNumber id="accentContainer3" className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small p-inputtext-sm" value={nonColorProperties.fontWeight}  onChange={(e) => setNonColorProperty("fontWeight", e.value)} />
                    </div>
                  </div>
                  <div className="slds-col slds-size_5-of-12 slds-m-top_medium">
                    <label htmlFor="accentContainer3">0 - 100</label>
                    <div className="slds-grid slds-m-top_x-small">
                    <Slider className="slds-size_11-of-12 slds-max-small-size_9-of-12 slds-m-left_x-small" value={nonColorProperties.fontWeight}  onChange={(e) => setNonColorProperty("fontWeight", e.value)} />
                    </div>
                  </div>
                </div>
            </AccordionTab>
          </Accordion>
        </div> 
    </div>
  );
}

export default Chat;
